
var dzs_open_social_link = function(arg,argthis){
  var leftPosition, topPosition;
  var w = 500, h= 500;
  //Allow for borders.
  leftPosition = (window.screen.width / 2) - ((w / 2) + 10);
  //Allow for title and status bars.
  topPosition = (window.screen.height / 2) - ((h / 2) + 50);
  var windowFeatures = "status=no,height=" + h + ",width=" + w + ",resizable=yes,left=" + leftPosition + ",top=" + topPosition + ",screenX=" + leftPosition + ",screenY=" + topPosition + ",toolbar=no,menubar=no,scrollbars=no,location=no,directories=no";






  arg = arg.replace('{{replacewithcurrurl}}',encodeURIComponent(window.location.href));
  if(argthis){

    arg = arg.replace(/{{replacewithdataurl}}/g,argthis.attr('data-url'));
  }

  var aux = window.location.href;


  var auxa = aux.split('?');

  var cid = '';
  var cid_gallery = '';

  if(argthis){
    if(jQuery(argthis).parent().parent().attr('data-menu-index')){

      cid = jQuery(argthis).parent().parent().attr('data-menu-index');
    }
    if(jQuery(argthis).parent().parent().attr('data-gallery-id')){

      cid_gallery = jQuery(argthis).parent().parent().attr('data-gallery-id');
    }
  }

  arg = arg.replace('{{shareurl}}',encodeURIComponent(auxa[0]+'?audiogallery_startitem_'+cid_gallery+'='+cid));

  //console.info(argthis);
  //console.info('arg - ',arg);
  window.open(arg,"sharer", windowFeatures);
};




const remove_query_arg_all = function remove_query_arg_all(purl){

  var fout = purl.split('&')[0];
  fout = fout.split('?')[0];

  return fout;

}
const add_query_args = function add_query_args(purl, keys){

  var fout = purl;
  var ind = 0;
  for(var key in keys){


    if(keys[key]){
      if(ind){
        fout+='&';
      }else{

        fout+='?';
      }

      var key_lab = key;

      if(key=='post_type'){
        key_lab = 'post_type_2';
      }



      fout+=key_lab+'='+encodeURIComponent(keys[key]);
      ind++;
    }

  }

  return fout;
}

const get_query_arg = function get_query_arg(purl, key){
  if(purl.indexOf(key+'=')>-1){
    //faconsole.log('testtt');
    var regexS = "[?&]"+key + "=.+";
    var regex = new RegExp(regexS);
    var regtest = regex.exec(purl);


    if(regtest != null){
      var splitterS = regtest[0];
      if(splitterS.indexOf('&')>-1){
        var aux = splitterS.split('&');
        splitterS = aux[1];
      }
      var splitter = splitterS.split('=');

      return splitter[1];

    }
    //$('.zoombox').eq
  }
}

const get_query_arg_all = function get_query_arg_all(purl){



  var arr = {};
  if(purl.indexOf('=')>-1){
    //faconsole.log('testtt');




    // var regexS = '[?|&].*?=(.*?)(?=&|$)';
    // var regex = new RegExp(regexS);

    var regex = /[?|&](.*?)=(.*?)(?=&|$)/g;

    var aux = null;
    while(aux = regex.exec(purl)){


      // console.info(aux);



      arr[aux[1]] = aux[2];

    }
  }

  return arr;
}

const add_query_arg = function add_query_arg(purl, key,value){
  key = encodeURIComponent(key); value = encodeURIComponent(value);

  //if(window.console) { console.info(key, value); };

  var s = purl;
  var pair = key+"="+value;

  var r = new RegExp("(&|\\?)"+key+"=[^\&]*");


  //console.info(pair);

  s = s.replace(r,"$1"+pair);
  //console.log(s, pair);
  var addition = '';


  // console.info('s -> ',s);
  if(s.indexOf(key + '=')>-1){


  }else{
    if(s.indexOf('?')>-1){
      addition = '&'+pair;
    }else{
      addition='?'+pair;
    }
    s+=addition;
  }

  //if value NaN we remove this field from the url
  if(value=='NaN'){
    var regex_attr = new RegExp('[\?|\&]'+key+'='+value);
    s=s.replace(regex_attr, '');
  }


  //if(!RegExp.$1) {s += (s.length>0 ? '&' : '?') + kvp;};

  return s;
}

module.exports.dzs_open_social_link = dzs_open_social_link;
module.exports.add_query_arg = add_query_arg;
module.exports.remove_query_arg_all = remove_query_arg_all;
module.exports.add_query_args = add_query_args;
module.exports.get_query_arg_all = get_query_arg_all;
module.exports.get_query_arg = get_query_arg;